// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer  from './authSlice';
import tasksReducer from './tasksSlice';

export const store = configureStore({
  reducer: {
    auth:  authReducer,
    tasks: tasksReducer,
  },
});

export default store;
